import { render, staticRenderFns } from "./FiltrosContratos.vue?vue&type=template&id=6479ce5a&"
import script from "./FiltrosContratos.vue?vue&type=script&lang=js&"
export * from "./FiltrosContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports